import axios from 'axios';
import Config from '@/Config';

const host = Config.host + "Product/"


function saveProduct(idCompany, product, category, description, costs){
  return axios.post(`${host}save`,{
    "idProduct": null,
    "idCompany": idCompany,
    "product": product,
    "category": category,
    "description": description,
    "costs": costs,
    "views": null
  })
    .then(data => {
      return data.data
    })
}
function saveProductEdit(product){
  return axios.post(`${host}save`, product)
    .then(data => {
      return data.data
    })
}

function getProductsCompany(idCompany){
  return axios.get(`${host}ProductsCompany/${idCompany}`)
    .then(data => {
      return data.data
    })
}
function getProductById(idProduct){
  return axios.get(`${host}${idProduct}`)
    .then(data => {
      return data.data
    })
} 
function ImagesProducts(idProduct) {
  return axios.get(`${host}ImagesProduct/${idProduct}`)
     .then(data => {
        return data.data
    })
}

function imageSave(imageBase64, idCompany){
  return axios.post(`${host}ImageSave`, {
    idEntity: idCompany,
    path: imageBase64
  }).then(data => {
        return data.data
    })
}

function deleteImage(idImage){
  return axios.delete(`${host}DeleteImage/${idImage}`)
    .then(data => {
      return data.data
    })
}

function isProductEnabled(idProduct) {
  return axios.get(`${host}isEnabled/${idProduct}`)
    .then(data => data.data)
}

function search(text, contry, city, page) {
  return axios.post(`${host}Search`, {
    text: text,
    contry: contry,
    city: city,
    page: page
  }).then(data => {
    return data.data
  })
}

function addProductView(idProduct) {
  return axios.post(`${host}${idProduct}/view`)
    .then(data => data.data)
}

function deleteProduct(idProduct) {
  return axios.delete(`${host}delete/${idProduct}`)
    .then(data => data.data)
}

/**
 * Sube la carta (imagen o PDF) para que Claude cree los productos.
 * Responde enseguida con el idCarga; el avance se consulta con estadoCarta.
 */
function cargarCarta(idCompany, archivo) {
  const datos = new FormData()
  datos.append('archivo', archivo)

  return axios.post(`${host}menu/${idCompany}`, datos)
    .then(data => data.data)
}

function estadoCarta(idCarga) {
  return axios.get(`${host}menu/estado/${idCarga}`)
    .then(data => data.data)
}

export default {
  cargarCarta,
  estadoCarta,
  saveProduct,
  getProductsCompany,
  getProductById,
  saveProductEdit,
  ImagesProducts,
  imageSave,
  deleteImage,
  isProductEnabled,
  search,
  addProductView,
  deleteProduct
}